import { useState } from "react";
import { useNavigate } from "react-router-dom";


const CreateArticle = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [mdFile, setMdFile] = useState(null);
  const [images, setImages] = useState([]);
  const [dt, setDt] = useState("");

  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

  // MDファイルを読み込んでcontentに設定
  const handleMdFileChange = async (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "text/markdown" || file.name.endsWith('.md'))) {
      setMdFile(file);

      // ファイル内容を読み込み
      const text = await file.text();
      setContent(text);

      // ファイル名から情報を抽出 (形式: YYYYMMDD_category_title.md)
      const fileName = file.name.replace(/\.md$/, '');
      const parts = fileName.split('_');

      if (parts.length >= 3) {
        // 日付を抽出 (YYYYMMDD → YYYY-MM-DD形式に変換)
        const datePart = parts[0];
        if (datePart.length === 8 && /^\d+$/.test(datePart)) {
          const formattedDate = `${datePart.substring(0, 4)}-${datePart.substring(4, 6)}-${datePart.substring(6, 8)}`;
          setDt(`${formattedDate} 00:00:00`); // 時間は00:00:00に設定
        }

        // カテゴリーを抽出
        setCategory(parts[1]);

        // タイトルを抽出 (残りの部分を結合)
        setTitle(parts.slice(2).join(' '));
      } else {
        // 形式が合わない場合はファイル名をそのままタイトルに
        setTitle(fileName);
      }
    } else {
      alert("Markdownファイルを選択してください (.md または .markdown)");
    }
  };

  // 画像ファイルの選択
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    setImages(files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // formData作成
      const formData = new FormData();
      formData.append('title', title);
      formData.append('category', category);
      formData.append('content', content);
      formData.append('dt', dt);
      // 画像ファイルを追加
      images.forEach((image, index) => {
        formData.append(`images`, image);
      });

      const response = await fetch(`${API_URL}/api/posts/upload`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        alert("記事投稿完了");

        // フォームをリセット
        setTitle("");
        setCategory("");
        setContent("");
        setMdFile(null);
        setImages([]);
        setDt("");
      } else {
        alert("投稿に失敗しました");
      }
    } catch (error) {
      console.error("投稿エラー:", error);
      alert("投稿に失敗しました");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg">

      <div style={{ paddingLeft: '50px' }}>
        {/* 🔙 戻るボタン */}
        < button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-4 text-blue-600 hover:underline"
          style={{ display: "block", marginTop: "10px", marginBottom: "10px" }}
        >
          ← 前に戻る
        </button >
      </div>

      <hr className="border-t border-gray-300 my-4 w-full" />

      <div style={{ paddingLeft: '50px' }}>
        <h2 className="text-2xl font-bold mb-6 text-gray-800">記事作成</h2>

        <form onSubmit={handleSubmit} >
          {/* MDファイルアップロード className="space-y-4"*/}
          <div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Markdownファイル 
                <span className="text-xs text-gray-500 ml-2"> <br />(ファイル形式: YYYYMMDD_category_title.md)</span>
              </label>
            </div>
            <div>
              <input
                type="file"
                accept=".md,.markdown"
                onChange={handleMdFileChange}
                required
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {mdFile && (
                <p className="text-sm text-green-600 mt-1" style={{ color: '#0055CC' }}>
                  選択されたファイル: {mdFile.name}
                </p>
              )}
            </div>
          </div>

          {/* 空白 */}
          <div style={{ height: '30px' }}>
          </div>

          {/* 画像アップロード */}
          <div className="mt-8">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                関連画像
                <span className="text-xs text-gray-500 ml-2"> <br />(サムネイル画像形式: YYYYMMDDthumbnail.jpg等  その他画像形式: 任意)</span>
              </label>
            </div>
            <div>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            {images.length > 0 && (
              <div className="mt-2">
                <p className="text-sm text-green-600" style={{ color: '#0055CC' }}>
                  選択された画像: {images.length}個
                </p>
                <div className="flex flex-col gap-1 mt-2">
                  {images.map((image, index) => (
                    <div key={index} className="text-xs bg-gray-100 px-2 py-1 rounded" style={{ color: '#0055CC' }}>
                      {image.name}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* 空白 */}
          <div style={{ height: '30px' }}>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-medium"
          >
            投稿
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateArticle;